import React from 'react';
import dayjs from "dayjs";

import {Stack} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Card from "@mui/joy/Card";

// components

import {BarChart} from "@mui/x-charts/BarChart";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import TotalCard from "./TotalCard";


dayjs.locale('ru');


class LaborReportYearChart extends React.Component {
    render() {
        let numberFormat = new Intl.NumberFormat('ru', {maximumFractionDigits: 2})
        return (
            <Card>
                <Typography
                    level={'h4'}
                >
                    Загрузка по задачам
                </Typography>
                <Stack
                    direction={'row'}
                    spacing={2}
                    useFlexGap
                    sx={{
                        justifyContent: "start",
                        alignItems: "center",
                        flexWrap: 'wrap'
                    }}
                >
                    <TotalCard
                        color={'grey'}
                        title={'Лимит загрузки'}
                        value={this.props.overallReport.total.capacity}
                        numberFormat={numberFormat}
                    />
                    <TotalCard
                        color={'grey'}
                        title={'Лимит загрузки 65%'}
                        value={this.props.overallReport.total.capacity_sixtyfive}
                        numberFormat={numberFormat}
                    />
                    <TotalCard
                        color={'success'}
                        title={'В трудоемкости'}
                        value={this.props.overallReport.total.phase}
                        numberFormat={numberFormat}
                    />
                    <TotalCard
                        color={'warning'}
                        title={'В сделке'}
                        value={this.props.overallReport.total.opportunity}
                        numberFormat={numberFormat}
                    />
                    <TotalCard
                        color={'danger'}
                        title={'Без сделки'}
                        value={this.props.overallReport.total.noOpportunity}
                        numberFormat={numberFormat}
                    />
                    <TotalCard
                        color={'error'}
                        title={'Потери'}
                        value={this.props.overallReport.total.lostCapacity}
                        numberFormat={numberFormat}
                    />
                    <TotalCard
                        color={'purple'}
                        title={'Переработка'}
                        value={this.props.overallReport.total.overload}
                        numberFormat={numberFormat}
                    />
                    <TotalCard
                        color={'pink'}
                        title={'Впереди'}
                        value={this.props.overallReport.total.toGo}
                        numberFormat={numberFormat}
                    />
                    <TotalCard
                        color={'teal'}
                        title={'В прогнозе'}
                        value={this.props.overallReport.total.forecast}
                        numberFormat={numberFormat}
                    />
                </Stack>
                <BarChart
                    dataset={this.props.overallReport.monthes}
                    series={[
                        {
                            dataKey: 'capacity_sixtyfive',
                            stack: 'capacity',
                            label: 'Лимит загрузки 65%',
                            color: '#706965',
                            highlightScope: {
                                highlight: 'series',
                                fade: 'global',
                            },
                        },
                        {
                            dataKey: 'capacity_thirtyfive',
                            stack: 'capacity',
                            label: 'Лимит загрузки 35%',
                            color: '#bab0ab',
                            highlightScope: {
                                highlight: 'series',
                                fade: 'global',
                            },
                        },
                        {
                            dataKey: 'overload',
                            stack: 'capacity',
                            label: 'Переработка',
                            color: '#e377c2',
                            highlightScope: {
                                highlight: 'series',
                                fade: 'global',
                            },
                        },
                        {
                            dataKey: 'phasePlan',
                            stack: 'plan',
                            label: 'В трудоемкости (План)',
                            color: '#59a14f',
                            highlightScope: {
                                highlight: 'series',
                                fade: 'global',
                            },
                        },
                        {
                            dataKey: 'opportunityPlan',
                            stack: 'plan',
                            label: 'В сделке (План)',
                            color: '#ff7f0e',
                            highlightScope: {
                                highlight: 'series',
                                fade: 'global',
                            },
                        },
                        {
                            dataKey: 'noOpportunityPlan',
                            stack: 'plan',
                            label: 'Без сделки (План)',
                            color: '#e15759',
                            highlightScope: {
                                highlight: 'series',
                                fade: 'global',
                            },
                        },
                        {
                            dataKey: 'phase',
                            stack: 'fact',
                            label: 'В трудоемкости',
                            color: '#59a14f',
                            highlightScope: {
                                highlight: 'series',
                                fade: 'global',
                            },
                        },
                        {
                            dataKey: 'opportunity',
                            stack: 'fact',
                            label: 'В сделке',
                            color: '#ff7f0e',
                            highlightScope: {
                                highlight: 'series',
                                fade: 'global',
                            },
                        },
                        {
                            dataKey: 'noOpportunity',
                            stack: 'fact',
                            label: 'Без сделки',
                            color: '#e15759',
                            highlightScope: {
                                highlight: 'series',
                                fade: 'global',
                            },
                        },
                        {
                            dataKey: 'lostCapacity',
                            stack: 'fact',
                            label: 'Потери',
                            color: '#d62728',
                            highlightScope: {
                                highlight: 'series',
                                fade: 'global',
                            },
                        },
                        {
                            dataKey: 'toGo',
                            stack: 'forecast',
                            label: 'Впереди',
                            color: '#ab1a82',
                            highlightScope: {
                                highlight: 'series',
                                fade: 'global',
                            },
                        },
                        {
                            dataKey: 'forecast',
                            stack: 'forecast',
                            label: 'Прогноз',
                            color: '#149366',
                            highlightScope: {
                                highlight: 'series',
                                fade: 'global',
                            },
                        },
                        {
                            dataKey: 'tail',
                            stack: 'forecast',
                            label: 'Хвост',
                            color: '#bcbd22',
                            highlightScope: {
                                highlight: 'series',
                                fade: 'global',
                            },
                        },
                    ]}
                    xAxis={[
                        {
                            dataKey: 'month',
                            scaleType: 'band',
                        }
                    ]}
                    height={400}
                />
                <CommonPaginatedTable
                    title={''}
                    data={this.props.overallReport.monthes}
                    fields={[
                        {
                            title: 'Месяц',
                            name: 'month',
                            visible: true,
                        },
                        {
                            name: 'capacity',
                            title: 'Лимит загрузки',
                            preProcess: (value) => (value?numberFormat.format(value):value),
                            visible: true,
                        },
                        {
                            name: 'capacity_sixtyfive',
                            title: 'Лимит загрузки 65%',
                            preProcess: (value) => (value?numberFormat.format(value):value),
                            visible: true,
                        },
                        {
                            name: 'phase',
                            title: 'В трудоемкости',
                            preProcess: (value) => (value?numberFormat.format(value):value),
                            visible: true,
                        },
                        {
                            name: 'phasePlan',
                            title: 'В трудоемкости (План)',
                            preProcess: (value) => (value?numberFormat.format(value):value),
                            visible: true,
                        },
                        {
                            name: 'opportunity',
                            title: 'В сделке',
                            preProcess: (value) => (value?numberFormat.format(value):value),
                            visible: true,
                        },
                        {
                            name: 'opportunityPlan',
                            title: 'В сделке (План)',
                            preProcess: (value) => (value?numberFormat.format(value):value),
                            visible: true,
                        },
                        {
                            name: 'noOpportunity',
                            title: 'Без сделки',
                            preProcess: (value) => (value?numberFormat.format(value):value),
                            visible: true,
                        },
                        {
                            name: 'noOpportunityPlan',
                            title: 'Без сделки (План)',
                            preProcess: (value) => (value?numberFormat.format(value):value),
                            visible: true,
                        },
                        {
                            name: 'lostCapacity',
                            title: 'Потери',
                            preProcess: (value) => (value?numberFormat.format(value):value),
                            visible: true,
                        },
                        {
                            name: 'overload',
                            title: 'Переработка',
                            preProcess: (value) => (value?numberFormat.format(value):value),
                            visible: true,
                        },
                    ]}
                />
            </Card>
        )
    }
}

export default LaborReportYearChart;